import { useApi } from '@/shared/api/http';

export const useCategoriesService = () => {
  const api = useApi();

  const getCategories = async (isAuth = false) => {
    try {
      return await api.get<any>('/products/categories/', isAuth);
    } catch (error) {
      console.error('Ошибка при получении категорий:', error);
      throw error;
    }
  };

  return {
    getCategories,
  };
};
